import { ListableInfo, OverflowTooltipLabel } from '@ics-portal/guardian';
import { type Maybe } from 'graphql/jsutils/Maybe';
import { type ReactNode } from 'react';

interface UrlListableInfoProps {
    label: string;
    url: Maybe<string>;
}

export function UrlListableInfo({
    label,
    url,
}: UrlListableInfoProps): ReactNode {
    return (
        <ListableInfo
            size="md"
            valueStyle={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}
            label={label}
            value={
                url ? (
                    <a
                        className="ics-text-link inline-block max-w-full text-truncate"
                        href={url}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <OverflowTooltipLabel
                            label={url}
                            tooltipPosition="top"
                        />
                    </a>
                ) : (
                    '-'
                )
            }
        />
    );
}
